export { useResponsiveEnvironment } from './lib/use-responsive-environment'
